import React from 'react';

const ProgressBar = ({ current, total, phase }) => {
  const percentage = (current / total) * 100;

  return (
    <div className="mb-8">
      {phase && (
        <p className="text-sm text-gray-600 mb-2">
          {phase} • Step {current} of {total}
        </p>
      )}
      <div className="progress-bar">
        <div
          className="progress-fill"
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
};

export default ProgressBar;
